<template>
  <div class="table-box">
    <QueryForm @QuerySearch="QuerySearch" :queryForm="queryForm"></QueryForm>
    <div style="display: none">
      <input
        @change="(e) => uploadInfo(e, '3')"
        id="speechUpload"
        type="file"
      />
    </div>
    <!--        <label for="speechUpload" class="labelImportBtn">-->
    <!--            <span>导入</span>-->
    <!--        </label>-->
    <el-button
      type="primary"
      icon="el-icon-download"
      class="button downOutBtns"
      @click="createExcel"
      >导出
    </el-button>
    <el-button type="primary" @click="returnAll">批量回访</el-button>
    <!--        <el-button type="danger" class="button" @click="mobandaochu"-->
    <!--            >模板导出-->
    <!--        </el-button>-->
    <div style="height: 20px"></div>

    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单流水号"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servePersonName"
          label="服务人员"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servetypename"
          label="服务类别"
          align="center"
          minWidth="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
         <el-table-column
          prop="serveproductNameStr"
          label="服务项目"
          align="center"
          minWidth="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeStart"
          label="服务开始时间"
          align="center"
          minWidth="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeEnd"
          label="服务结束时间"
          align="center"
          minWidth="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="realPeriod"
          label="服务时长"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          :show-overflow-tooltip="true"
          fixed="right"
          width="250"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="callback(row, '查看')"
              >查看
            </el-button>
            <el-button type="text" @click="callback(row, '回访')"
              >回访
            </el-button>
            <el-button type="text" @click="callback(row, '编辑')"
              >编辑
            </el-button>
            <!-- <el-button type="text" @click="callback(row, '申请作废')"
              >作废
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 20px"></div>
    <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <VisitDialog
      ref="visitDialog"
      @updateList="getDataList"
      :show-visit.sync="showVisit"
      :showTitle="showTitle"
      :orderInfo="callbackForm"
    ></VisitDialog>

    <el-dialog
      title="回访"
      :visible.sync="dialogVisible"
      width="65%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-row :gutter="10" class="dialogBtns">
        <el-button :type="display === 0 ? 'primary' : 'info'" @click="sendMsg"
          >工单信息
        </el-button>
        <el-button
          v-show="btnActive"
          :type="display === 3 ? 'primary' : 'info'"
          @click="callbackingMag"
        >
          处理中回访信息
        </el-button>
        <el-button
          :type="display === 1 ? 'primary' : 'info'"
          @click="disposeMsg"
          >处理信息
        </el-button>

        <el-button
          v-show="btnActive"
          :type="display === 2 ? 'primary' : 'info'"
          @click="callbackMag"
          >回访信息
        </el-button>
        <el-button
          v-show="btnActive"
          :type="display === 4 ? 'primary' : 'info'"
          @click="InfoMag"
          >补充资料
        </el-button>
      </el-row>
      <CallbackVisitDialog
        ref="CallbackVisitDialog"
        @updateList="getDataList"
        :orderInfo="callbackForm"
        v-show="display === 0"
      ></CallbackVisitDialog>
      <!-- 处理信息 -->
      <div v-show="display === 1">
        <div style="height: 12px; margin-top: 30px"></div>
        <el-form disabled label-width="180px" ref="form" :model="callbackForm">
          <el-form-item label="APP用户反馈语音评价：">
            <el-input v-model="callbackForm.evaluate"></el-input>
          </el-form-item>
          <audio
            controls="controls"
            preload="auto"
            class="audioActive"
            :src="callbackForm.estimateRecord"
          ></audio>
          <!-- <el-form-item label="第二次语音评价：">
              <el-input
                  v-model="callbackForm.thirdEstimateRecord"
              ></el-input>
          </el-form-item>
          <audio
              controls="controls"
              preload="auto"
              class="audioActive"
              :src="callbackForm.estimate"
          ></audio> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间：">
                <el-input v-model="callbackForm.timeStart"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间：">
                <el-input v-model="callbackForm.timeEnd"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="服务内容：">
            <el-input
              disabled
              type="textarea"
              v-model="callbackForm.visitContent"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作图片：">
            <el-row :gutter="10">
              <el-col :span="6" class="imgBox">
                <!-- <img
                    v-if="callbackForm.picStart"
                    :src="callbackForm.picStart"
                    alt="工作开始图片"
                /> -->
                <el-image
                  v-if="callbackForm.picStart"
                  :src="callbackForm.picStart"
                  class="img"
                  :preview-src-list="[callbackForm.picStart]"
                ></el-image>
                <div class="photoName">工作开始</div>
              </el-col>
              <el-col :span="6" class="imgBox">
                <!-- <img
                    v-if="callbackForm.picFinished"
                    :src="callbackForm.picFinished"
                    alt="工作结束图片"
                /> -->
                <el-image
                  v-if="callbackForm.picFinished"
                  :src="callbackForm.picFinished"
                  class="img"
                  :preview-src-list="[callbackForm.picFinished]"
                ></el-image>
                <div class="photoName">工作结束</div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="工作视频：">
            <div class="uploadBox">
              <div class="uploadFlex">
                <!-- {{gongdanForm.video}} -->
                <video
                  id="myvideo1"
                  :src="callbackForm.videoUrl"
                  style="height: 100px; width: 200px; margin: 0 10px"
                  ref="videoId"
                  autoplay="true"
                  controls
                  muted
                ></video>
              </div>
            </div>
          </el-form-item>
          <!-- <el-divider></el-divider>
<div style="height: 12px; margin-top: 30px; color: #169bd5">
  是否合格
</div>
<el-divider></el-divider>
<el-form-item label="状态：" prop="active">
  <el-radio-group
      v-model="callbackForm.failure"
      @change="disqualificationFun"
  >
    <el-radio label="合格"></el-radio>
    <el-radio label="不合格"></el-radio>
  </el-radio-group>
</el-form-item> -->
        </el-form>
      </div>
      <!--  处理中回访信息 -->
      <div v-show="display === 3">
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          处理中回访信息
        </div>
        <el-divider></el-divider>
        <el-form label-width="180px" ref="form" :model="callbackForm">
          <el-form-item label="服务人员是否准时：">
            <el-radio-group disabled v-model="callbackForm.isOnTime">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务态度是否良好：">
            <el-radio-group disabled v-model="callbackForm.isGood">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务时间是否符合规范：">
            <el-radio-group disabled v-model="callbackForm.isStandard">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拨打状态：" prop="dialingStatus">
            <el-radio-group v-model="callbackForm.dialingStatus" disabled>
              <el-radio label="0">正常接听</el-radio>
              <el-radio label="1">无人接听</el-radio>
              <el-radio label="2">关机</el-radio>
              <el-radio label="3">停机</el-radio>
              <el-radio label="4">空号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务人员着装是否整洁：">
            <el-radio-group disabled v-model="callbackForm.isTidy">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务对象评价：">
            <el-input
              disabled
              type="textarea"
              v-model="callbackForm.ojectEvaluation"
            ></el-input>
          </el-form-item>
          <audio
            controls="controls"
            preload="auto"
            class="audioActive"
            :src="callbackForm.estimateVoiceRecord"
          ></audio>
          <el-form-item label="回访结果：">
            <el-radio-group v-model="callbackForm.results" disabled>
              <el-radio label="0">合格</el-radio>
              <el-radio label="1">不合格</el-radio>
              <el-radio label="2">作废</el-radio>
              <el-radio label="3">虚假工单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="理由：">
            <el-input
              type="textarea"
              v-model="callbackForm.reason"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 回访信息 -->
      <div v-show="display === 2">
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          回访信息
        </div>
        <el-divider></el-divider>
        <el-form label-width="180px" ref="form" :model="callbackForm">
          <el-form-item label="客户名称：">
            <el-col :span="10">
              <el-input v-model="callbackForm.customerName" disabled></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input
                  v-model="callbackForm.customerphone"
                  disabled
                ></el-input>
              </el-col>
              <el-col :span="1">
                <i
                  class="el-icon-phone"
                  title="电话"
                  style="cursor: pointer"
                  @click="callPhone(callbackForm.customerphone, '1')"
                ></i>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="地址:">
            <div style="display: flex; margin-bottom: 5px">
              <el-input
                disabled
                placeholder="请输入"
                v-model="callbackForm.provinceName"
              ></el-input>
              <el-input
                disabled
                placeholder="请输入"
                v-model="callbackForm.city"
              ></el-input>
              <el-input
                disabled
                placeholder="请输入"
                v-model="callbackForm.areaName"
              ></el-input>
              <el-input
                disabled
                placeholder="请输入"
                v-model="callbackForm.streetName"
              ></el-input>
              <!-- @change="handleCommunityChange" -->
              <el-input
                disabled
                placeholder="请输入"
                v-model="callbackForm.communityName"
              ></el-input>
            </div>
            <el-input
              v-model="callbackForm.address"
              style="padding: 0px; border: 0"
              disabled
              class="el-input__inner"
              placeholder="请输入关键字"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px">
            <audio
              controls="controls"
              style="margin-left: 0"
              preload="auto"
              class="audioActive"
              :src="callbackForm.recVisit"
            ></audio>
          </el-form-item>
          <el-form-item label="图片：">
            <el-upload
              :action="actionUrl"
              :show-file-list="false"
              :on-success="
                (file, fileList) => {
                  handleAvatarSuccess(file, fileList)
                }
              "
              :before-upload="beforeAvatarUpload"
              accept=".jpg,.png"
            >
              <div class="avatar" v-if="callbackForm.pictureVisit">
                <img
                  :src="callbackForm.pictureVisit"
                  style="width: 178px; height: 178px"
                />
              </div>
              <div v-else>
                <i
                  class="el-icon-plus avatar_uploader avatar-uploader-icon"
                  style="border: 1px solid #ddd"
                ></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否通过App处理工单：" prop="fromApps">
            <el-radio-group v-model="callbackForm.fromApps" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传图片是否符合规范：" prop="rightPic">
            <el-radio-group v-model="callbackForm.rightPic" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务时间是否符合规范：" prop="rightTime">
            <el-radio-group v-model="callbackForm.rightTime" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拨打状态：" prop="dialStatus">
            <el-radio-group v-model="callbackForm.dialStatus">
              <el-radio label="0">正常接听</el-radio>
              <el-radio label="1">无人接听</el-radio>
              <el-radio label="2">关机</el-radio>
              <el-radio label="3">停机</el-radio>
              <el-radio label="4">空号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否上传语音评价：" prop="rightEstimateRecord">
            <el-radio-group
              v-model="callbackForm.rightEstimateRecord"
              @change="timeTap"
            >
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务对象评价：">
            <el-input
              type="textarea"
              v-model="callbackForm.estimate"
            ></el-input>
          </el-form-item>
          <el-form-item label="服务企业（组织）评价：">
            <el-input
              type="textarea"
              v-model="callbackForm.jiamengEstimate"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户满意度：">
            <el-select
              v-model="callbackForm.estimateLevel"
              placeholder="请选择"
            >
              <el-option value="0" label="未评价"></el-option>
              <el-option value="1" label="没有服务"></el-option>
              <el-option value="2" label="不满意"></el-option>
              <el-option value="3" label="服务一般"></el-option>
              <el-option value="4" label="基本满意"></el-option>
              <el-option value="5" label="非常满意"></el-option>
              <!-- <el-option
    v-for="item in estimateLevelList"
    :key="item.value"
    :label="item.label"
    :value="item.value"
>
</el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="是否上门：">
            <el-radio-group v-model="callbackForm.visited">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="回访结果：">
            <el-radio-group
              v-model="callbackForm.visitResults"
              @change="visitTap"
            >
              <el-radio label="0">合格</el-radio>
              <el-radio label="1">不合格</el-radio>
              <el-radio label="2">作废</el-radio>
              <el-radio label="3">虚假工单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="理由：">
            <el-input
              type="textarea"
              v-model="callbackForm.visitReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 补充资料 -->
      <div v-show="display === 4">
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          补充资料
        </div>
        <el-divider></el-divider>
        <el-form label-width="180px" ref="form" disabled :model="serverinfoObj">
          <el-form-item label="上传录音：" prop="suppleRecord">
            <audio
              controls="controls"
              style="margin-left: 0"
              preload="auto"
              class="audioActive"
              :src="serverinfoObj.suppleRecord"
            ></audio>
          </el-form-item>
          <el-form-item label="上传视频：" prop="suppleVideo">
            <div class="uploadBox">
              <div class="uploadFlex">
                <video
                  id="myvideo1"
                  :src="serverinfoObj.suppleVideo"
                  style="height: 200px; width: 300px; margin: 0 10px"
                  ref="videoId"
                  autoplay="true"
                  controls
                  muted
                ></video>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上传图片：" prop="supplePic">
            <el-upload
              :action="actionUrl"
              :file-list="fileList"
              list-type="picture-card"
              :limit="10"
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div class="btn">
        <div>
          <el-button type="primary" @click="send">确定</el-button>
          <el-button @click="handleClose" type="info">取消</el-button>
          <el-button type="success" @click="handleTip" v-show="display === 2"
            >指派
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="指派"
      :visible.sync="handleVisible"
      width="30%"
      :before-close="toCancel"
      :close-on-click-modal="false"
    >
      <el-form
        :model="serviceH"
        label-width="90px"
        :rules="rules"
        ref="serviceH"
      >
        <el-form-item label="机构:" prop="servesStation">
          <el-select
            v-model="serviceH.servesStation"
            @change="getService"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in serviceStaData"
              :key="index"
              :value="item.id"
              :label="item.statName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务人员:" prop="servesName">
          <el-select
            v-model="serviceH.servesName"
            @change="changeName"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in serviceService"
              :key="index"
              :value="item.id"
              :label="item.personName"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
          "
        >
          <el-button @click="toSend('serviceH')" type="primary"
            >确定
          </el-button>
          <el-button @click="toCancel('serviceH')" type="info">取消 </el-button>
        </div>
      </el-form>
    </el-dialog>

    <VisitDialog
      ref="visitDialog"
      @updateList="getDataList"
      :show-visit.sync="showVisit"
      :showTitle="showTitle"
      :orderInfo="callbackForm"
    ></VisitDialog>

    <returnVisit2
      v-if="dialogVisible1"
      ref="returnVisit"
      @updateList="updateList"
      v-model="dialogVisible1"
      :showTitle="showTitle"
      :deal-flag="true"
      :orderInfo="returnInfo"
    >
    </returnVisit2>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"
import VisitDialog from "../component/visitDialog.vue"
import CallbackVisitDialog from "../component/callbackVisitDialog"
import headLine from "../../components/headline"
import baseURL from "@/api/baseURL"
import exportVue from "@/utils/exportVue"
import audioLink from "@/api/audio"
import returnVisit2 from "../component/returnVisit2.vue"

export default {
  components: {
    VisitDialog,
    headLine,
    QueryForm,
    CallbackVisitDialog,
    returnVisit2,
  },
  data() {
    return {
      showVisit: false,
      showTitle: "",
      dataId: 0,
      queryForm: {
        orderName: "",
        customerType: "",
        serveproductName: "",
        servestationName: "",
        servePersonName: "",
        serviceTypeName:'',
        provinceId: '',
        cityId: '',
        zoneId: '',
        streetId: '',
        shequId: '',
      },
      chooseRadio: [],
      tableData: [],
      serviceH: {
        servesStation: "",
        servesName: "",
      },
      serverinfoObj: {
        supplePic: [],
        suppleVideo: "",
        suppleRecord: "",
      },
      fileList: [],
      serviceStaData: [],
      serviceService: [],
      handleVisible: false,
      totalCount: 0,
      multipleSelection: [],
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogVisible1: false,
      sendActive: true,
      btnActive: true,
      display: 0,
      callbackForm: {
      },
      estimateLevelList: [
        { value: "0", label: "未评价" },
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "基本满意" },
        { value: "5", label: "非常满意" },
      ],
      rules: {
        servesStation: [
          {
            required: true,
            message: "请选择机构",
            trigger: "change",
          },
        ],
        servesName: [
          {
            required: true,
            message: "请选择服务人员",
            trigger: "change",
          },
        ],
      },
      isCome0ptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      isSearchContent: true,
    }
  },
  created() {
    this.getDataList()
    this.getStationList()
  },
  methods: {
    updateList() {
      this.dialogVisible1 = false
      this.getDataList()
    },
    // 回访
    visitTap(val) {
      // this.callbackForm.visitResults = val
      this.$forceUpdate()
    },
    Reset() {
      this.queryForm = {}
      this.getDataList()
    },
    send() {
      const serverObj = this.$refs.CallbackVisitDialog.serverObj
      const changeContent = this.$refs.CallbackVisitDialog.changeContent
      const self = this
      const data = Object.assign(serverObj, this.callbackForm)
      data.closeReason = self.callbackForm.visitReason
      if (Array.isArray(changeContent)) {
        data.changeContent = changeContent.join(",")
      }
      data.states = "3"
      let url = ""
      if (self.callbackForm.visitResults == 0) {
        url = "/jjyl/servicePgd/info/Visit"
      } else if (self.callbackForm.visitResults == 1) {
        if (self.callbackForm.visitReason == undefined) {
          self.$message.error("请输入不合格理由")
          return
        }
        url = "/jjyl/servicePgd/info/visitAbnormal"
        data.id = self.callbackForm.id
      } else {
        if (self.callbackForm.visitReason == undefined) {
          self.$message.error("请输入理由")
          return
        }
        url = "/jjyl/servicePgd/info/Invalid"
        data.states = self.callbackForm.visitResults == 2 ? "4" : "8"
        // 添加作废理由
        data.visitReason = self.callbackForm.visitReason
        data.orderNum = self.callbackForm.orderNum
        data.id = self.callbackForm.id
        // 添加作废申请人
        data.askCloseName = self.$store.state.info.name
      }
      request({
        url: "/jjyl/servicePgd/info/Visit",
        method: "POST",
        data: {
          ...data,
          id: this.dataId,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (
            self.callbackForm.visitResults == 2 ||
            self.callbackForm.visitResults == 3
          ) {
            self.getCancle(url, data)
          } else if (self.callbackForm.visitResults == 1) {
            self.getNoPass(url, data)
          } else {
            this.$message.success(res.message)
            this.handleClose()
            this.getDataList()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.$set(this.callbackForm, "pictureVisit", res.content)
    },
    beforeAvatarUpload() {},
    // 作废 虚拟工单
    getCancle(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //不合格
    getNoPass(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //回访弹窗打开
    // 点击回访
    callback(row, title) {
      this.showTitle = title
      row.repeats = row.orderNum.indexOf("-") != -1 ? true : false
      this.returnInfo = row
      this.dialogVisible1 = true
    },
    // async callback(id) {
    //   this.dialogVisible = true
    //   console.log(id)
    //   this.dataId = id
    //   await this.getDetails(id)
    // },
    // 回访弹框关闭
    handleClose() {
      this.display = 0
      this.dialogVisible = false
      this.callbackForm = {}
      if (this.$refs.CallbackVisitDialog) {
        this.$refs.CallbackVisitDialog.changeContent = []
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    mobandaochu() {
      this.request2({
        url: "/jjyl/servicePgd/info/Templatedownload",
        method: "POST",
        data: {
          pageNo: this.query.pageNum,
          pageSize: this.query.pageSize,
        },
        responseType: "blob",
      }).then((resp) => {
        if (resp) {
          const blob = new Blob([resp], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "导入模板.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出成功")
        }
      })
    },
    createExcel() {
      this.request2({
        url: "/jjyl/servicePgd/info/export",
        method: "POST",
        excel: true,
        data: {
          customerphone: this.queryForm.customerphone,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          orderNum: this.queryForm.orderNum,
          states: "2",
          type: this.queryForm.customerType || "3",
          // customerType: this.queryForm.customerType,
          customerName: this.queryForm.customerName,
          timeStart: this.queryForm.timeStart,
          timeEnd: this.queryForm.timeEnd,
          position: this.queryForm.position,
          servestationName: this.queryForm.servestationName,
          serveproductName: this.queryForm.serveproductName,
          servePersonName: this.queryForm.servePersonName,
          serviceTypeName:this.queryForm.serviceTypeName
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "残联工单.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === "1") {
        return "没有服务"
      } else if (row.estimateLevel === "2") {
        return "不满意"
      } else if (row.estimateLevel === "3") {
        return "服务一般"
      } else if (row.estimateLevel === "4") {
        return "基本满意"
      } else if (row.estimateLevel === "5") {
        return "非常满意"
      }
    },
    async detailsVisit(title, row) {
      if (title === "新增") {
        this.showTitle = title
        this.showVisit = true
      } else {
        this.showTitle = title
        await this.getDetails(row.id)
        this.showVisit = true
      }
    },
    getDataList() {
      let params = {
        customerphone: this.queryForm.customerphone,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        orderNum: this.queryForm.orderNum,
        states: "2",
        type: this.queryForm.customerType || "3",
        customerUserType: this.queryForm.customerUserType,
        customerName: this.queryForm.customerName,
        timeStart: this.queryForm.timeStart,
        timeEnd: this.queryForm.timeEnd,
        position: this.queryForm.position,
        provinceId: this.queryForm.provinceId,
        cityid: this.queryForm.cityid,
        zoneid: this.queryForm.zoneid,
        streetid: this.queryForm.streetid,
        shequid: this.queryForm.shequid,
        servestationName: this.queryForm.servestationName,
        serveproductName: this.queryForm.serveproductName,
        servePersonName: this.queryForm.servePersonName,
        serviceTypeName:this.queryForm.serviceTypeName,
        city: "",
        zone: "",
        street: "",
        shequ: "",
      }
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    getDetails(id) {
      request({
        url: "/jjyl/servicePgd/info/findServicepgdById",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.callbackForm = res.content
            this.callbackForm.videoUrl = res.content.videoUrl
            this.callbackForm.recVisit =
              audioLink + "/" + this.callbackForm.recVisit
          } else {
            this.callbackForm = {}
          }
        }
      })
    },
    //指派
    handleTip() {
      this.handleVisible = true
    },
    getStationList() {
      let params = {
        pageNO: 1,
        pageSize: 99,
      }
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceStaData = res.content.list || []
          } else {
            this.serviceStaData = []
          }
        }
      })
    },
    getService() {
      this.$set(this.serviceH, "servesName", "")
      this.serviceService = []
      this.getServiceData()
    },
    getServiceData() {
      let params = {
        pageNO: 1,
        pageSize: 99,
        serviceStationId: this.serviceH.servesStation,
      }
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceService = res.content.list || []
          } else {
            this.serviceService = []
          }
        }
      })
    },
    changeName(val) {
      this.serviceService.forEach((item) => {
        if (item.id == val) {
          this.serviceH.appointName = item.personName
        }
      })
    },
    toSend(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            appoint: this.serviceH.servesName,
            appointName: this.serviceH.appointName,
            servicePgdId: this.dataId,
          }
          request({
            url: "/jjyl/servicePgdReturnVisit/info/save ",
            method: "POST",
            data: params,
          }).then((res) => {
            if (res.code === 200) {
              this.handleVisible = false
              this.handleClose()
              this.getDataList()
            }
          })
        } else {
          return false
        }
      })
    },
    toCancel(formName) {
      this.handleVisible = false
      this.$refs[formName].resetFields()
    },
    QuerySearch() {
      this.getDataList()
    },
    //派发
    sendMsg() {
      this.display = 0
    },
    //处理
    disposeMsg() {
      this.display = 1
    },
    //回访
    callbackMag() {
      this.display = 2
      this.callbackForm.fromApps = "0"
      this.callbackForm.rightPic = "0"
      this.callbackForm.rightTime = "0"
      this.callbackForm.visited = "0"
      this.callbackForm.visitResults = "0"
      this.callbackForm.rightEstimateRecord = "0"
      this.chooseRadio = [1, 1, 1, 1]
    },
    //补充资料
    InfoMag() {
      this.display = 4
      this.fileList = []
      request({
        url: "/jjyl/servicePgdSupple/info/get",
        method: "POST",
        data: {
          servicePgdId: this.dataId,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content == null || res.content == "null") {
            this.serverinfoObj = {}
          } else {
            this.serverinfoObj = res.content
            this.serverinfoObj.suppleRecord = res.content.suppleRecord
            this.serverinfoObj.suppleVideo = res.content.suppleVideo
            if (this.serverinfoObj.supplePic.length > 0) {
              this.serverinfoObj.supplePic =
                this.serverinfoObj.supplePic.split(",")
              this.fileList = this.serverinfoObj.supplePic.map((item) => {
                return {
                  url: item,
                }
              })
            }
          }
        }
      })
    },
    //回访中
    callbackingMag() {
      this.display = 3
    },
    // 切换评价 results
    timeTap(val) {
      if (val == 0) {
        this.chooseRadio.push(1)
      } else {
        this.chooseRadio.splice(0, 1)
      }
      console.log(
        this.chooseRadio.length,
        this.chooseRadio.length < 2,
        "选中情况"
      )
      if (this.chooseRadio.length < 2) {
        this.callbackForm.visitResults = "1"
      } else {
        this.callbackForm.visitResults = "0"
      }
      this.$forceUpdate()
    },
    // 点击撤回
    chehui(id) {
      let params = {
        servicePgdId: id,
      }
      this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgdReturnVisit/info/withdraw",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("撤回成功")
          } else {
            this.$message.error("撤回失败")
          }
          this.getDataList()
        })
      })
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },
    returnAll() {
      var ids = this.multipleSelection.map(item => item.id)
      if (ids.length > 0) {
        this.callbackForm.estimate='满意'
        this.callbackForm.jiamengEstimate='满意'
        this.callbackForm.estimateLevel='5'
      console.log(this.callbackForm,'this.callbackForm')
      this.$forceUpdate()
        this.$confirm("确认批量回访吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            request({
                url: "/jjyl/servicePgd/info/batchReturnVisit",
                method: "POST",
                data: {
                  ids: ids
                },
              })
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "批量回访成功!",
            })
            setTimeout(() => this.getDataList(), 500)
          })
      } else {
        this.$message({
          type: "warning",
          message: "请选择要回访的项!",
        })
      }
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
    //不合格事件
    disqualificationFun(data) {
      this.btnActive = data !== "不合格"
    },
    //打电话
    callPhone(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type)
        }, 5000)
      }
    },
    // 拨号处理
    callType(phone, type) {
      const self = this
      request({
        url: "/jjyl/traffic/callInfo/info/saveCallIdforNormalPdg",
        method: "POST",
        data: {
          remoteNum: phone,
          agentID: self.$store.state.seatNo,
          servicepgdId: self.dataId,
          callToType: type,
        },
      }).then((res) => {})
    },
  },
}
</script>

<style lang="less" scoped>
.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;

  div {
    flex: 1;
  }
}

.dialogBtns {
  display: flex;
  justify-content: center;

  .el-button {
    margin-right: 40px;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.audioActive {
  margin-left: 180px;
  margin-bottom: 20px;
}

.imgBox {
  height: 200px;
  width: 150px;

  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .img {
    margin-bottom: 10px;
    width: 100px;
    height: 100px;
  }

  .photoName {
    width: 70%;
    background-color: #169bd5;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}

.hui {
  color: #999;
}

.blue {
  color: #409eff;
}
</style>
